/**
 * @generated SignedSource<<d968f3ceafbca0f4dcdc70a4e75c9492>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion$data = ReadonlyArray<{
  readonly id: string;
  readonly routine?: {
    readonly id: string;
  };
  readonly taskExecution?: {
    readonly routine: {
      readonly id: string;
    } | null;
  };
  readonly " $fragmentType": "useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion";
}>;
export type useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion$key = ReadonlyArray<{
  readonly " $data"?: useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Routine",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      (v0/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskExecutionCheck",
          "kind": "LinkedField",
          "name": "taskExecution",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "type": "TeamScheduleInlineRoutineOccasion",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "RoutineOccasion",
      "abstractKey": null
    }
  ],
  "type": "TeamScheduleEventOccasion",
  "abstractKey": "__isTeamScheduleEventOccasion"
};
})();

(node as any).hash = "e56fc0747a524ee226500e9aaba3661c";

export default node;
